<template>
  <edit-modal
    caption="Nieuw Rapport"
    :isActive="isActive">
    <div class="field">
      <div class="control">
        <input class="input" type="text" placeholder="Naam" v-model="name">
      </div>
    </div>

    <save-buttons
      @save="save"
      @cancel="close">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { bus } from '@/main'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'tableId'
  ],
  components: {
    EditModal,
    SaveButtons
  },
  data () {
    return {
      isActive: false,
      id: null,
      name: null
    }
  },
  created () {
    let self = this
    bus.$on('toggleReportModal', function (payload) {
      if (payload.report) {
        self.id = payload.report.id
        self.name = payload.report.name
      }

      self.toggle(payload.state)
    })
  },
  methods: {
    toggle (state) {
      this.isActive = state
    },
    save () {
      this.$store.dispatch('reports/save', {
        id: this.id,
        name: this.name,
        table_id: this.tableId
      })

      this.isActive = false
    },
    close () {
      this.id = this.name = null
      this.isActive = false
    }
  }
}
</script>
